import SimpleSignSteps from './SimpleSignSteps';

export default SimpleSignSteps;
